import { FileMedia, IFileMedia } from "./file-media.model";
import { IQuestion, Question } from "./question.model";

export interface ISurvey {
  surveyId: string;
  neighborhoodId: string;
  title: string;
  content: string;
  total: number;
  dueDate: string;
  status: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  questions?: IQuestion[];
  files?: IFileMedia[];
}

export class Survey {
  surveyId: string;
  neighborhoodId: string;
  title: string;
  content: string;
  total: number;
  dueDate: string;
  status: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  questions: Question[];
  files: FileMedia[];

  constructor(data: ISurvey) {
    this.surveyId = data.surveyId;
    this.neighborhoodId = data.neighborhoodId;
    this.title = data.title;
    this.content = data.content;
    this.total = data.total;
    this.dueDate = data.dueDate;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.questions = data.questions
      ? data.questions.map(
          (question) => new Question(question)
        )
      : [];
    this.files = data.files
      ? data.files.map(
          (file) => new FileMedia(file)
        )
      : [];
  }
}
